import { ReactNode } from "react";
import { Button, Container, Skeleton } from "../../shared/ui";
import { VacancyList, VacancyListSkeleton } from "../../entities/Vacancy";

import { classNames } from "../../shared/lib/classNames";
import { CareerBackInterfacesDTOVacancyGroupVacanciesByDirectionDto } from "../../shared/ApiContract/data-contracts";
import { buildSequentialArray } from "../../shared/lib/helpers";

import styles from "./VacanciesList.module.scss";

/**
 * @param renderButton кнопка для перехода по ссылке на странице вакансий или пагинации на странице направления (данные отсутствуют)
 */
interface VacanciesListProps {
    className?: string;
    isLoading?: boolean;
    vacancyList?: CareerBackInterfacesDTOVacancyGroupVacanciesByDirectionDto[] | null;
    vacancyItemStart?: number;
    vacancyItemEnd?: number;
    renderButton?: (data: Record<"id" | "className", string>) => ReactNode;
}

export const VacanciesList = ({ className, vacancyList, isLoading = false, renderButton }: VacanciesListProps) => {
    const handleClick = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <Container marginSize="standard" className={classNames({ cls: styles.vacanciesList, additional: [className] })}>
            {isLoading ? (
                <VacanciesListSkeleton />
            ) : (
                <>
                    <ul className={styles.vacanciesList__list}>
                        {vacancyList?.length ? (
                            vacancyList.map(({ direction, vacancies }) => (
                                <li key={direction?.name} className={styles.vacanciesList__directionList}>
                                    <p className={styles.vacanciesList__title}>{direction?.name}</p>
                                    <VacancyList isLoading={isLoading} jobList={vacancies ?? []} />
                                    {direction?.id &&
                                        renderButton?.({
                                            id: direction.id,
                                            className: styles.vacanciesList__button,
                                        })}
                                </li>
                            ))
                        ) : (
                            <div className={styles.vacanciesList__empty}>
                                <p className={styles.vacanciesList__subTitle}>
                                    Сейчас у&nbsp;нас нет вакансий по&nbsp;вашим параметрам
                                </p>
                                <p>Попробуйте изменить критерии поиска</p>
                                <Button
                                    as={"button"}
                                    onClick={handleClick}
                                    className={styles.vacanciesList__subscribe}
                                    theme={"blue"}
                                >
                                    Изменить
                                </Button>
                            </div>
                        )}
                    </ul>
                </>
            )}
        </Container>
    );
};

const VacanciesListSkeleton = () => (
    <>
        <Skeleton className={styles.skeleton__count} />
        <ul className={styles.vacanciesList__list}>
            {buildSequentialArray(2).map((item) => (
                <li key={item} className={styles.vacanciesList__directionList}>
                    <Skeleton className={styles.skeleton__title} />
                    <VacancyListSkeleton />
                </li>
            ))}
        </ul>
    </>
);
